import { PageHeader } from '@ant-design/pro-layout'
import { useSuspenseQuery } from '@apollo/client'
import { FetchDimensionGroupsDocument } from '@salescore/client-api'
import { getOrganizationIdFromPath, useCanForFeatures } from '@salescore/client-common'
import { DimensionGroupsTable, UpsertDimensionGroupForm } from '@salescore/client-feature-setting'
// eslint-disable-next-line sonarjs/deprecation
import { useModal } from '@salescore/frontend-common'
import { createFileRoute } from '@tanstack/react-router'
import { Alert, Button, Modal } from 'antd'
import { startTransition } from 'react'
import { useTranslation } from 'react-i18next'

const Page = () => {
  // eslint-disable-next-line sonarjs/deprecation
  const createModal = useModal()
  const { t } = useTranslation()
  const { data, refetch } = useSuspenseQuery(FetchDimensionGroupsDocument, {
    variables: { organizationId: getOrganizationIdFromPath() },
  })
  const invalidate = () => {
    startTransition(() => {
      void refetch()
    })
  }
  // eslint-disable-next-line sonarjs/no-dead-store,sonarjs/no-unused-vars
  const { dimensionGroups, models, goalDimensions, goalConfigs } = data

  const { canManageDimensionGroup } = useCanForFeatures()
  if (!canManageDimensionGroup) {
    // そもそも辿り着かないはずなので、最小限のUIにしている
    return (
      <div>
        <Alert type="warning" message={t(`権限がありません`)} />
      </div>
    )
  }

  return (
    <PageHeader
      title={t(`分析軸グループ一覧`)}
      extra={[
        <Button
          key="create"
          type="primary"
          onClick={() => {
            createModal.showModal()
          }}
        >
          {t('新規作成')}
        </Button>,
      ]}
    >
      <DimensionGroupsTable
        dimensionGroups={dimensionGroups}
        goalDimensions={goalDimensions}
        models={models}
        refetch={() => {
          invalidate()
        }}
      />
      <Modal
        open={createModal.isModalVisible}
        onCancel={createModal.hideModal}
        width={'60%'}
        cancelText={t(`閉じる`)}
        okButtonProps={{ style: { display: 'none' } }}
        title={<div></div>}
        style={{ top: '3%' }}
        destroyOnHidden
      >
        <UpsertDimensionGroupForm
          onAfterFinish={() => {
            invalidate()
            createModal.hideModal()
          }}
        />
      </Modal>
    </PageHeader>
  )
}

export const Route = createFileRoute('/o/$organizationId/v2/settings/dimension_groups')({
  component: Page,
})
